// result.schema.json source — REUSES the P2 module, does not duplicate it.
// `../autopilot-result-schema.js` is the single source (per phase file:
// "reuse `autopilot-result-schema.ts` (P2)"); this file only re-exports so
// every schemas/*-schema.ts module can be imported the same way by the
// generator and by tests.
export {
  AUTOPILOT_RESULT_JSON_SCHEMA_STRING,
  type AutopilotResult,
  AutopilotResultSchema,
} from "../autopilot-result-schema.js";
